module.exports = __webpack_public_path__ + "svg/ruby.95a788.svg";